import "./markup-menu";
import $ from 'jquery';
global.$ = global.jQuery = $;
import rangeslider from 'rangeslider.js';
import { svg } from './components/svg';
import { sliders } from './components/sliders';
import { main } from './components/main';
import "slick-carousel";
import 'jquery-countdown'
import animations from './components/animations';
import 'jquery.maskedinput/src/jquery.maskedinput';
import map from "./components/map";
import stepform from './components/step-form';
import Select from './components/select';
import datepicker from 'js-datepicker'
require('particles.js')
require('readmore-js');

document.addEventListener("DOMContentLoaded", () => {
  svg();
  map();
  sliders();
  setTimeout(() => {
    animations();
  }, 700);
  $('input[type="tel"]').mask("+38(999) 999-99-99");
  $('.bottom-calc input[type="text"]').mask("+38(999) 999-99-99");
  main();

  if ($('#step-form').length) {
    stepform();

    datepicker('.date-input', {
      startDay: 1,
      customMonths: calendarMonths,
      customDays: calendarDays,
      formatter: (input, date) => {
        const value = date.toLocaleDateString()
        input.value = value
      },
      disabler: date => (date <= new Date(new Date().setDate(new Date().getDate()-1))),
    })
  }

  global.customSelect = new Select();

  if ($('#timer').length) {
    var count = 3600;
    var counter = setInterval(timer, 1000); //1000 will  run it every 1 second

    function timer() {
      count = count - 1;
      if (count == -1) {
          clearInterval(counter);
          return;
      }

      var seconds = count % 60;
      var minutes = Math.floor(count / 60);
      var hours = Math.floor(minutes / 60);
      minutes %= 60;
      hours %= 60;

      document.getElementById("timer").innerHTML = hours + ":" + minutes + ":" + seconds; // watch for spelling
    }
  }

  if ($('#particles-js').length) {
    particlesJS.load('particles-js', '/wp-content/themes/cronvest/assets/images/particles.json', function() {});
  }
  if ($('#particles-js-2').length) {
    particlesJS.load('particles-js-2', '/wp-content/themes/cronvest/assets/images/particles.json', function() {});
  }



  if ($('.calc').hasClass('main-calc')) {
    $('.field-sum').each(function () {
  		$(this).on('keyup', function () {
  			if ($(this).val() > Number($(this).attr("max"))) {
  				var val = $(this).val().slice(0, $(this).attr("max").length);
  				$(this).val(val);
  			}
  		});
  	});

    $('input[name="valute"]').on('change', function(){
      $('#currency').val($(this).siblings('span').text());
    });

    $('input[name="checked"]').on('change', function(){
      $('#status').val($(this).siblings('span').text());
    });
    $('input[name="checked2"]').on('change', function(){
      var value = '';

      if($(this).hasClass('mont-hidden-input')){
        value = $(this).siblings('span').find('.mouth').val();
      }else{
        value = $(this).siblings('span').text();
      }
      $('#variants').val(value);
    });
    $('input.mouth').on('change', function(){
      $('#variants').val($(this).val());
    });

    function numberWithCommas(number) {
    	var parts = number.toString().split(".");
    	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    	return parts.join(" ");
    }

    var $amount = $('.field-sum');
    var percent1 = 0;
    var percent2 = 0;
    var inputvalue = 0;
    var num = $('.count').text();
    var commaNum = numberWithCommas(num);
    $('.count').text(commaNum);

  	$('input[type=range]').rangeslider({
  			polyfill: false
  	})
  	.on('input', function () {
  		$amount[0].value = this.value;
  			$('.count').text(numberWithCommas(this.value));
        $('#sum').val(this.value);
        if ($('#check-3').is(':checked') && $('#check-5').is(':checked')) {
        		var percent1 = this.value * $('#check-3').data('percent');
        } else if ($('#check-4').is(':checked') && $('#check-5').is(':checked')) {
        		var percent1 = this.value * $('#check-4').data('percent');
        }
        else if ($('#check-3').is(':checked') && $('#check-6').is(':checked')) {
        		var percent1 = this.value * $('#check-6').data('percent') + (this.value / $('.mouth').val());
        }
        else if ($('#check-4').is(':checked') && $('#check-6').is(':checked')) {
        		var percent1 = this.value * $('#check-6').data('percent') + (this.value / $('.mouth').val());
        }
        $('.count-2').text(parseInt(percent1));
          var inputvalue = this.value;
        });
        $amount.on('change', function () {
        	$('input[type=range]').val(this.value).change();
        });
        $('input:radio[name="valute"]').change(
        	function () {
        		if ($(this).is(':checked') && $(this).attr("id") == "check-1") {
        		    $('.count-sum .val, .val-2').text('USD');
        		} else if ($(this).is(':checked') && $(this).attr("id") == "check-2") {
        	     $('.count-sum .val, .val-2').text('ГРН');
        		}
        });

        $('input:radio[name="checked"], input:radio[name="checked2"]').change(
        	function () {
      		  var sumbase = $('.field-sum').val().replace(/ /g, '');
          	if ($('#check-3').is(':checked') && $('#check-5').is(':checked')) {
          		var percent1 = sumbase * $('#check-3').data('percent');

          	} else if ($('#check-4').is(':checked') && $('#check-5').is(':checked')) {
          		var percent1 = sumbase * $('#check-4').data('percent');
          	} else if ($('#check-3').is(':checked') && $('#check-6').is(':checked')) {
          		var percent1 = sumbase * $('#check-6').data('percent') + (sumbase / $('.mouth').val());
          	} else if ($('#check-4').is(':checked') && $('#check-6').is(':checked')) {
          		var percent1 = sumbase * $('#check-6').data('percent') + (sumbase / $('.mouth').val());
          	}
          	$('.count-2').text(parseInt(percent1));

        	});
          $('body').on('change', '.mouth', function() {
            var sumbase = $('.field-sum').val().replace(/ /g, '');
            if ($('#check-3').is(':checked') && $('#check-5').is(':checked')) {
              var percent1 = sumbase * $('#check-3').data('percent');

            } else if ($('#check-4').is(':checked') && $('#check-5').is(':checked')) {
              var percent1 = sumbase * $('#check-4').data('percent');
            } else if ($('#check-3').is(':checked') && $('#check-6').is(':checked')) {
              var percent1 = sumbase * $('#check-6').data('percent') + (sumbase / $('.mouth').val());
            } else if ($('#check-4').is(':checked') && $('#check-6').is(':checked')) {
              var percent1 = sumbase * $('#check-6').data('percent') + (sumbase / $('.mouth').val());
            }
            $('.count-2').text(parseInt(percent1));
          });
  }
  if ($('.sub-calc').hasClass('sub-page-calc')) {
    $('.field-sum').each(function () {
  		$(this).on('change', function () {
  			if ($(this).val() > Number($(this).attr("max"))) {
  				var val = $(this).val().slice(0, $(this).attr("max").length);
  				$(this).val(val);
  			}
  		});
  	});

    function numberWithCommas(number) {
    	var parts = number.toString().split(".");
    	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    	return parts.join(" ");
    }

    function numberWithCommasnew(number) {
      var parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(" ");
    }
    var $amount = $('.field-sum');
    var percent1 = 0;
    var percent2 = 0;
    var inputvalue = 0;
    var num = $('.count').text();
    var commaNum = numberWithCommas(num);
    $('.count').text(commaNum);
  	$('input[type=range]').rangeslider({
  			polyfill: false
  	})
  	.on('input', function () {
  		$amount[0].value = this.value;
        var percentnew = this.value * $('#check-3').data('percent');
        var percentnew2 = this.value * $('#check-4').data('percent');
        $('.sub-count-1').text(numberWithCommas(percentnew));
        $('.sub-count-2').text(numberWithCommas(percentnew2));
        $('#sum').val(this.value);
        if ($('#check-3').is(':checked') && $('#check-5').is(':checked')) {
        		var percent1 = percentnew * $('#check-5').data('percent');
            $('.count').text(numberWithCommas(percentnew));
            $('.count-2').text(numberWithCommas(percent1));
        } else if ($('#check-4').is(':checked') && $('#check-5').is(':checked')) {
        		var percent1 = percentnew2 * $('#check-5').data('percent');
            $('.count').text(numberWithCommas(percentnew2));
            $('.count-2').text(numberWithCommas(percent1));
        }
        else if ($('#check-3').is(':checked') && $('#check-6').is(':checked')) {
        		var percent1 = percentnew * $('#check-6').data('percent') + (this.value / $('.mouth').val());
            $('.count').text(numberWithCommas(percentnew));
        }
        else if ($('#check-4').is(':checked') && $('#check-6').is(':checked')) {
        		var percent1 = percentnew2 * $('#check-6').data('percent') + (this.value / $('.mouth').val());
            $('.count').text(numberWithCommas(percentnew2));
        }
        $('.count-2').text(parseInt(percent1));
          var inputvalue = this.value;
        });
        $amount.on('change', function () {
        	$('input[type=range]').val(this.value).change();
        });
        $('input:radio[name="valute"]').change(
        	function () {
            if ($(this).is(':checked') && $(this).attr("id") == "check-1") {
        		    $('.count-sum .val, .val-2, .sub-count-1 strong, .sub-count-2 strong').text('usd');
        		} else if ($(this).is(':checked') && $(this).attr("id") == "check-2") {
        	     $('.count-sum .val, .val-2, .sub-count-1 strong, .sub-count-2 strong').text('грн');
        		}
        });

        $('input:radio[name="checked"], input:radio[name="checked2"]').change(
        	function () {
      		  var sumbase = $('.field-sum').val().replace(/ /g, '');
            var sumbase1 = sumbase * $('#check-3').data('percent');
            var sumbase2 = sumbase * $('#check-4').data('percent');
          	if ($('#check-3').is(':checked') && $('#check-5').is(':checked')) {
          		var percent1 = sumbase1 * $('#check-5').data('percent');
              $('.count').text(numberWithCommas(sumbase1));
          	} else if ($('#check-4').is(':checked') && $('#check-5').is(':checked')) {
          		var percent1 = sumbase2 * $('#check-5').data('percent');
              $('.count').text(numberWithCommas(sumbase2));
          	} else if ($('#check-3').is(':checked') && $('#check-6').is(':checked')) {
          		var percent1 = sumbase1 * $('#check-6').data('percent') + (sumbase / $('.mouth').val());
              $('.count').text(numberWithCommas(sumbase1));
          	} else if ($('#check-4').is(':checked') && $('#check-6').is(':checked')) {
          		var percent1 = sumbase2 * $('#check-6').data('percent') + (sumbase / $('.mouth').val());
              $('.count').text(numberWithCommas(sumbase2));
          	}
          	$('.count-2').text(parseInt(percent1));

        	});
          $('body').on('change', '.mouth', function() {
            var sumbase = $('.field-sum').val().replace(/ /g, '');
            var sumbase1 = sumbase * $('#check-3').data('percent');
            var sumbase2 = sumbase * $('#check-4').data('percent');
            if ($('#check-3').is(':checked') && $('#check-5').is(':checked')) {
              var percent1 = sumbase1 * $('#check-5').data('percent');

            } else if ($('#check-4').is(':checked') && $('#check-5').is(':checked')) {
              var percent1 = sumbase2 * $('#check-5').data('percent');
            } else if ($('#check-3').is(':checked') && $('#check-6').is(':checked')) {
              var percent1 = sumbase1 * $('#check-6').data('percent') + (sumbase / $('.mouth').val());
            } else if ($('#check-4').is(':checked') && $('#check-6').is(':checked')) {
              var percent1 = sumbase2 * $('#check-6').data('percent') + (sumbase / $('.mouth').val());
            }
            $('.count-2').text(parseInt(percent1));
          });
  }

});



// WEBPACK FOOTER //
// app/scripts/index.js